import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

export const Root = styled("div")(({ theme }) => ({
  padding: "0 16px",
  [theme.breakpoints.up("mobile")]: {
    marginTop: 27,
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 30,
  },
}));

export const HeaderWrapper = styled("div")(({ theme }) => ({
  height: 68,
  display: "flex",
  justifyContent: "end",
  position: "relative",
  [theme.breakpoints.up("mobile")]: {
    position: "absolute",
    right: 14,
    top: 20,
  },
  [theme.breakpoints.up("tablet")]: {
    position: "absolute",
    top: 25,
    right: 24,
  },
}));

export const CancelIconButton = styled("button")(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 500,
  color: theme.palette.text.primary,
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.pxToRem(20),
  },
}));

export const Content = styled("div")(({ theme }) => ({
  maxWidth: 338,
  margin: "0 auto",
  [theme.breakpoints.up("mobile")]: {
    width: 506,
    maxWidth: "none",
  },
  [theme.breakpoints.up("tablet")]: {
    width: 632,
    maxWidth: "none",
  },
}));

export const Terms = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridColumnGap: 13,
  gridRowGap: 18,
  [theme.breakpoints.up("mobile")]: {
    gridColumnGap: 20,
    gridRowGap: 27,
  },
  [theme.breakpoints.up("tablet")]: {
    gridColumnGap: 24,
    gridRowGap: 35,
  },
}));

export const TermButton = styled("button")(({ theme }) => ({
  height: 33,
  borderRadius: 16.5,
  fontSize: theme.typography.pxToRem(12),
  fontFamily: "Inter",
  fontWeight: 500,
  textTransform: "none",
  transition: "transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
  color: theme.palette.primary.main,
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  [theme.breakpoints.up("mobile")]: {
    height: 50,
    borderRadius: 25,
    fontSize: theme.typography.pxToRem(22.5),
  },
  [theme.breakpoints.up("tablet")]: {
    height: 62,
    borderRadius: 31,
    fontSize: theme.typography.pxToRem(28),
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  "&:nth-of-type(8n + 1)": {
    backgroundColor: theme.palette.searchTerms.yellow,
  },
  "&:nth-of-type(8n + 2)": {
    backgroundColor: theme.palette.searchTerms.blue,
  },
  "&:nth-of-type(8n + 3)": {
    backgroundColor: theme.palette.searchTerms.green,
  },
  "&:nth-of-type(8n + 4)": {
    backgroundColor: theme.palette.searchTerms.pink,
  },
  "&:nth-of-type(8n + 5)": {
    backgroundColor: theme.palette.searchTerms.red,
  },
  "&:nth-of-type(8n + 6)": {
    backgroundColor: theme.palette.searchTerms.yellow,
  },
  "&:nth-of-type(8n + 7)": {
    backgroundColor: theme.palette.searchTerms.violin,
  },
  "&:nth-of-type(8n)": {
    backgroundColor: theme.palette.searchTerms.orange,
  },
}));

export const SearchField = styled("div")(({ theme }) => ({
  position: "relative",
  marginBottom: 20,
  [theme.breakpoints.up("mobile")]: {
    marginTop: 13,
    marginBottom: 30,
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 16,
    marginBottom: 38,
  },
}));

export const SearchInputIcon = styled(SearchIcon)(({ theme }) => ({
  position: "absolute",
  left: 14,
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: theme.typography.pxToRem(24),
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.pxToRem(30),
    left: 24,
  },
  [theme.breakpoints.up("tablet")]: {
    fontSize: theme.typography.pxToRem(38),
    left: 30,
  },
}));

export const SearchInputStyled = styled("input")(({ theme }) => ({
  backgroundClip: "padding-box",
  width: "100%",
  height: 40,
  borderRadius: 20,
  borderWidth: 2,
  borderStyle: "solid",
  borderColor: alpha(theme.palette.primary.main, 0.15),
  padding: "0 53px 0 53px",
  fontSize: theme.typography.pxToRem(17),
  caretColor: theme.palette.secondary.main,
  color: theme.palette.text.primary,
  "&:focus": {
    outline: "none",
  },
  [theme.breakpoints.up("mobile")]: {
    height: 60,
    borderRadius: 30,
    borderWidth: 3,
    fontSize: theme.typography.pxToRem(26),
    paddingLeft: 80,
  },
  [theme.breakpoints.up("tablet")]: {
    height: 75,
    borderRadius: 37.5,
    borderWidth: 4,
    fontSize: theme.typography.pxToRem(32),
    paddingLeft: 100,
  },
}));

export const ResetSearchButton = styled("button")(({ theme }) => ({
  position: "absolute",
  right: 0,
  top: "50%",
  padding: 12,
  transform: "translateY(-50%)",
  background: "none",
  border: "none",
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    opacity: 0.7,
  },
  [theme.breakpoints.up("mobile")]: {
    right: 6,
  },
  [theme.breakpoints.up("tablet")]: {
    right: 12,
  },
}));

export const ResetSearchIcon = styled(CloseIcon)(({ theme }) => ({
  backgroundColor: "#F2F2F2",
  borderRadius: "100%",
  padding: 5,
  fontSize: theme.typography.pxToRem(20),
  color: theme.palette.text.primary,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.pxToRem(24),
  },
  [theme.breakpoints.up("tablet")]: {
    fontSize: theme.typography.pxToRem(28),
  },
}));
